const bankAccounts = {
  'bankAccounts.dailyLimits': 'limite diário',
  'bankAccounts.total': 'valor total',
  'bankAccounts.used': 'utilizado',
  'bankAccounts.available': 'disponível',
  'bankAccounts.limits': 'Limites diários',
  'bankAccounts.bankSlips': 'Boletos',
  'bankAccounts.Valor máximo de retirada P2P': 'Valor máximo de retirada P2P',
  'bankAccounts.Valor máximo de retirada P2P por dia':
    'Valor máximo de retirada P2P por dia',
  'bankAccounts.Valor máximo de retirada TEF': 'Valor máximo de retirada TEF',
  'bankAccounts.Valor máximo de retirada TEF por dia':
    'Máximo em retirada TED/TEF mesma titularidade por dia',
  'bankAccounts.Valor máximo de retirada TED': 'Valor máximo de retirada TED',
  'bankAccounts.Valor máximo de retirada TED por dia':
    'Máximo em retirada TED/TEF mesma titularidade por dia',
  'bankAccounts.Valor máximo de compras': 'Valor máximo de compras',
  'bankAccounts.Valor máximo de compras por dia':
    'Máximo em movimentações por dia (transferências, TED/TEF outras titularidade)',
  'bankAccounts.Valor máximo de cartões Pismo': 'Valor máximo de cartões Pismo',
  'bankAccounts.Valor máximo de cartões Pismo por dia':
    'Máximo em movimentações com cartões Pismo por dia, até o máximo disponível em movimentações por dia',
  'bankAccounts.Valor máximo de outros cartões':
    'Valor máximo de outros cartões',
  'bankAccounts.Valor máximo de outros cartões por dia':
    'Máximo em movimentações com outros cartões por dia, até o  máximo disponível em movimentações por dia',
  'bankAccounts.Valor máximo de solicitação por pagamento por dia':
    'Valor máximo de solicitação por pagamento por dia',
  'bankAccounts.Valor máximo por boleto': 'Valor máximo por boleto',
  'bankAccounts.Valor máximo de boletos por mês':
    'Valor máximo de boletos por mês',
  'bankAccounts.Valor mínimo por boleto': 'Valor mínimo por boleto',
  'bankAccounts.Número de boletos por dia': 'Número de boletos por dia',
  'bankAccounts.paymentRequests': 'Solicitações de pgto.',
  'bankAccounts.Valor máximo de solicitação por pagamento para PF':
    'Máximo para cobrar outros clientes PF',
  'bankAccounts.Valor máximo de solicitação por pagamento para PJ':
    'Máximo para cobrar outros clientes PJ',
  'bankAccounts.Valor máximo de mesma titularidade TED por dia':
    'Máximo em retirada TED/TEF mesma titularidade por dia',
};

export default bankAccounts;
